
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.8.2
 * Query Engine version: 2060c79ba17c6bb9f5823312b6f6b7f4a845738e
 */
Prisma.prismaVersion = {
  client: "6.8.2",
  engine: "2060c79ba17c6bb9f5823312b6f6b7f4a845738e"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  password: 'password',
  avatar: 'avatar',
  isVerified: 'isVerified',
  role: 'role',
  email: 'email',
  emailVerified: 'emailVerified',
  skills: 'skills',
  resume: 'resume',
  resume_text: 'resume_text',
  oauthProvider: 'oauthProvider',
  oauthId: 'oauthId',
  createdAt: 'createdAt',
  blockedByAdmin: 'blockedByAdmin',
  onBoard: 'onBoard',
  githubLink: 'githubLink',
  portfolioLink: 'portfolioLink',
  linkedinLink: 'linkedinLink',
  twitterLink: 'twitterLink',
  discordLink: 'discordLink',
  contactEmail: 'contactEmail',
  aboutMe: 'aboutMe',
  resumeUpdateDate: 'resumeUpdateDate',
  companyId: 'companyId'
};

exports.Prisma.CompanyScalarFieldEnum = {
  id: 'id',
  companyName: 'companyName',
  companyLogo: 'companyLogo',
  companyEmail: 'companyEmail',
  companyBio: 'companyBio'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  token: 'token',
  identifier: 'identifier',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type'
};

exports.Prisma.JobScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  title: 'title',
  description: 'description',
  companyName: 'companyName',
  companyBio: 'companyBio',
  companyEmail: 'companyEmail',
  category: 'category',
  type: 'type',
  workMode: 'workMode',
  currency: 'currency',
  city: 'city',
  address: 'address',
  application: 'application',
  companyLogo: 'companyLogo',
  skills: 'skills',
  expired: 'expired',
  hasExpiryDate: 'hasExpiryDate',
  expiryDate: 'expiryDate',
  hasSalaryRange: 'hasSalaryRange',
  minSalary: 'minSalary',
  maxSalary: 'maxSalary',
  hasExperiencerange: 'hasExperiencerange',
  minExperience: 'minExperience',
  maxExperience: 'maxExperience',
  isVerifiedJob: 'isVerifiedJob',
  deleted: 'deleted',
  deletedAt: 'deletedAt',
  postedAt: 'postedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BookmarkScalarFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  userId: 'userId'
};

exports.Prisma.ExperienceScalarFieldEnum = {
  id: 'id',
  companyName: 'companyName',
  designation: 'designation',
  EmploymentType: 'EmploymentType',
  address: 'address',
  workMode: 'workMode',
  currentWorkStatus: 'currentWorkStatus',
  startDate: 'startDate',
  endDate: 'endDate',
  description: 'description',
  userId: 'userId'
};

exports.Prisma.EducationScalarFieldEnum = {
  id: 'id',
  instituteName: 'instituteName',
  degree: 'degree',
  fieldOfStudy: 'fieldOfStudy',
  startDate: 'startDate',
  endDate: 'endDate',
  userId: 'userId'
};

exports.Prisma.ProjectScalarFieldEnum = {
  id: 'id',
  projectName: 'projectName',
  projectThumbnail: 'projectThumbnail',
  projectSummary: 'projectSummary',
  projectLiveLink: 'projectLiveLink',
  projectGithub: 'projectGithub',
  stack: 'stack',
  userId: 'userId',
  isFeature: 'isFeature'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.Role = exports.$Enums.Role = {
  USER: 'USER',
  ADMIN: 'ADMIN',
  HR: 'HR'
};

exports.OauthProvider = exports.$Enums.OauthProvider = {
  GOOGLE: 'GOOGLE'
};

exports.TokenType = exports.$Enums.TokenType = {
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  RESET_PASSWORD: 'RESET_PASSWORD'
};

exports.EmployementType = exports.$Enums.EmployementType = {
  Full_time: 'Full_time',
  Part_time: 'Part_time',
  Internship: 'Internship',
  Contract: 'Contract'
};

exports.WorkMode = exports.$Enums.WorkMode = {
  remote: 'remote',
  hybrid: 'hybrid',
  office: 'office'
};

exports.Currency = exports.$Enums.Currency = {
  INR: 'INR',
  USD: 'USD'
};

exports.DegreeType = exports.$Enums.DegreeType = {
  BTech: 'BTech',
  MTech: 'MTech',
  BCA: 'BCA',
  MCA: 'MCA'
};

exports.FieldOfStudyType = exports.$Enums.FieldOfStudyType = {
  AI: 'AI',
  Machine_Learning: 'Machine_Learning',
  CS: 'CS',
  Mechanical: 'Mechanical'
};

exports.ProjectStack = exports.$Enums.ProjectStack = {
  GO: 'GO',
  PYTHON: 'PYTHON',
  MERN: 'MERN',
  NEXTJS: 'NEXTJS',
  AI_GPT_APIS: 'AI_GPT_APIS',
  SPRINGBOOT: 'SPRINGBOOT',
  OTHERS: 'OTHERS'
};

exports.Prisma.ModelName = {
  User: 'User',
  Company: 'Company',
  VerificationToken: 'VerificationToken',
  Job: 'Job',
  Bookmark: 'Bookmark',
  Experience: 'Experience',
  Education: 'Education',
  Project: 'Project'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
